import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import Breadcrumb from "components/Breadcrumb";
import { useLocation } from "react-router-dom";
import { searchTemplates } from "api/templateService";
import SearchDetailCategoryManager from "./data/SearchDetailCategoryManager";
import DetailCategoryManagerTable from "./data/DetailCategoryManagerTable";

function DetailCategoryTables({ workingPage, childPage }) {
  const location = useLocation();
  const selectedCategory = location.state?.selectedCategory;

  const [totalElements, setTotalElements] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [rowsCount, setRowsCount] = useState(10);
  const [detailCategoryData, setDetailCategoryData] = useState([]);
  const [searchData, setSearchData] = useState({
    name: "",
    page: curPage,
    size: rowsCount,
    categoryId: selectedCategory?.categoryId || null,
  });

  // Cập nhật page, size, categoryId khi curPage hoặc rowsCount đổi
  useEffect(() => {
    setSearchData((prev) => ({
      ...prev,
      page: curPage,
      size: rowsCount,
      categoryId: selectedCategory?.categoryId || null,
    }));
  }, [curPage, rowsCount, selectedCategory]);

  useEffect(() => {
    searchTemplates(searchData).then((data) => {
      if (data.object) {
        setDetailCategoryData(data.object.datas);
        setTotalElements(data.object.totals);
      }
    });
  }, [searchData.page, searchData.size, searchData.name, searchData.categoryId]);

  const clickToSearch = () => {
    setCurPage(0);
    searchTemplates(searchData).then((data) => {
      if (data.object) {
        setDetailCategoryData(data.object.datas);
        setTotalElements(data.object.totals);
      }
    });
  };

  const refreshDataAfterChange = () => {
    searchTemplates(searchData).then((data) => {
      if (data.object) {
        setDetailCategoryData(data.object.datas);
        setTotalElements(data.object.totals);
      }
    });
  };

  const renderData = useMemo(
    () => (
      <DetailCategoryManagerTable
        data={detailCategoryData}
        totalElements={totalElements}
        curPage={curPage}
        setCurPage={setCurPage}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        refreshDataAfterChange={refreshDataAfterChange}
      />
    ),
    [curPage, rowsCount, totalElements, detailCategoryData]
  );

  return (
    <DashboardLayout>
      <DashboardNavbarCustom page={workingPage} childPage={childPage} />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              <Breadcrumb
                items={[
                  {
                    label: "Quản lý danh mục",
                    onClick: () => window.history.back(),
                  },
                  "Chi tiết danh mục",
                ]}
              />
              <SearchDetailCategoryManager
                clickSearch={clickToSearch}
                setSearchData={setSearchData}
                searchData={searchData}
                refreshDataAfterChange={refreshDataAfterChange}
                selectedCategory={selectedCategory}
              />
              {renderData}
            </Grid>

            <Grid item xs={0.2} />
          </Grid>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

DetailCategoryTables.defaultProps = {
  workingPage: "",
  childPage: [],
};

DetailCategoryTables.propTypes = {
  workingPage: PropTypes.string,
  childPage: PropTypes.arrayOf(PropTypes.string),
};

export default DetailCategoryTables;
